import { getTotalBrandCount } from "@faire/retailer-visitor-shared/lib/getMarketingCount";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import {
  popSignUp,
  SignUpElement,
  SignUpType,
} from "@faire/retailer-visitor-shared/lib/popSignUp";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackSeoBannerSignUpToShopCtaClick } from "@faire/web-api--source/events/seo/click/bannerSignUpToShopCta";
import React, { type JSX } from "react";
import { useHistory } from "react-router-dom";

const LinkFormatting = (chunks: JSX.Element, handleSignUp: () => void) => (
  <EmbeddedLink onClick={handleSignUp}>{chunks}</EmbeddedLink>
);
export const BrandsCountBanner: React.FC = () => {
  const { isTabletAndAbove } = useViewport();
  const history = useHistory();
  const brandCount = getTotalBrandCount();

  const handleSignUp = () =>
    popSignUp(history, SignUpType.GENERIC, trackSeoBannerSignUpToShopCtaClick, {
      element: SignUpElement.TOP_BANNER,
      sourceId: "brand_count_banner",
    });

  if (!isLoggedInRetailer() && isTabletAndAbove) {
    return (
      <Typography align="center">
        <StrictLocalMsg
          defaultMessage="Shop wholesale online from over {brandCountNumber} brands. <LinkFormatting>Sign up</LinkFormatting>"
          values={{
            brandCountNumber: brandCount,
            LinkFormatting: (chunk: JSX.Element) =>
              LinkFormatting(chunk, handleSignUp),
          }}
          description={{
            text: "Top banner text shown for prospective retailers detailing the number of brands on Faire's platform. The 'Sign up' link re-directs the logged-out user to a modal for signing up on Faire.",
          }}
        />
      </Typography>
    );
  }

  return (
    <Typography align="center">
      <StrictLocalMsg
        defaultMessage="Shop wholesale online from over {brandCount} brands."
        values={DEPRECATED_backwardsCompatibleValues({ brandCount })}
        description={{
          text: "Top banner text shown for prospective retailers detailing the number of brands on Faire's platform.",
        }}
      />
    </Typography>
  );
};
